import { isEmpty } from "lib/lodash";
import { designSmartTextSelector } from "../smartAssets/smartAssetsSelectors";
import { getCurrentDesignData } from "state/ui/editor/editorSelectors";

export const smartTextSelector = state => {
  return {
    ...state.entities.smartText.team,
    ...state.entities.smartText.user
  };
};

/**
 * Document Smart Text — fields defined on the current Design instance.
 * Keys are the bare ids (e.g. "storeLocation"); to compose with the
 * `{doc.<id>}` token namespace, prefix each key when merging into a
 * unified smart text context.
 *
 * Returns {} when no design is loaded or no document fields are defined.
 */
export const documentSmartTextSelector = state => {
  const design = getCurrentDesignData(state);
  return design?.documentSmartText || {};
};

/**
 * Suggestion source for autocomplete — combines team + user + document keys.
 * Document keys are prefixed with `doc.` so the inserted token matches
 * the same regex (`{doc.<id>}`) used at resolution time.
 */
export const allSmartTextWithDocumentSelector = state => {
  const baseSmartText = smartTextSelector(state);
  const documentFields = documentSmartTextSelector(state);

  const combined = { ...baseSmartText };
  Object.keys(documentFields).forEach(id => {
    combined[`doc.${id}`] = documentFields[id];
  });
  return combined;
};

// export const designSmartTextSelector = state =>
//   state.entities.smartText.design?.smartText;

export const teamSmartTextSearchSelector = state => {
  const teamSmartTextEntities = state.entities.smartText.team;
  const smartText = [];

  Object.keys(teamSmartTextEntities).forEach(text => {
    smartText.push(teamSmartTextEntities[text]);
  });

  return smartText;
};

export const allTeamSmartTextSelector = state => state.entities.smartText.team;

export const teamSmartTextSelector = state => {
  const teamSmartTextEntities = allTeamSmartTextSelector(state);
  const teamSmartText = [];

  Object.keys(teamSmartTextEntities).forEach(smartText => {
    if (
      !teamSmartTextEntities[smartText].hasOwnProperty("overridden") ||
      (teamSmartTextEntities[smartText].hasOwnProperty("overridden") &&
        teamSmartTextEntities[smartText].overridden)
    ) {
      teamSmartText.unshift(teamSmartTextEntities[smartText]);
    }
  });
  return teamSmartText;
};

export const teamSmartTextOverideSelector = state => {
  const teamSmartTextEntities = state.entities.smartText.team;
  const overrideSmartText = [];

  Object.keys(teamSmartTextEntities).forEach(smartText => {
    if (
      teamSmartTextEntities[smartText].hasOwnProperty("overridden") &&
      !teamSmartTextEntities[smartText].overridden
    ) {
      overrideSmartText.push(teamSmartTextEntities[smartText]);
    }
  });

  return overrideSmartText;
};

export const allUserTeamSmartTextSelector = state =>
  state.entities.smartText.user;

export const userTeamSmartTextSelector = state => {
  const smartTextEntities = allUserTeamSmartTextSelector(state);
  const userSmartText = [];

  Object.keys(smartTextEntities).forEach(smartText => {
    if (
      !smartTextEntities[smartText].hasOwnProperty("overridden") ||
      (smartTextEntities[smartText].hasOwnProperty("overridden") &&
        smartTextEntities[smartText].overridden)
    ) {
      userSmartText.unshift(smartTextEntities[smartText]);
    }
  });
  return userSmartText;
};

export const userTeamSmartTextOverideSelector = state => {
  const smartTextEntities = state.entities.smartText.user;
  const overrideSmartText = [];

  Object.keys(smartTextEntities).forEach(smartText => {
    if (
      smartTextEntities[smartText].hasOwnProperty("overridden") &&
      !smartTextEntities[smartText].overridden
    ) {
      overrideSmartText.push(smartTextEntities[smartText]);
    }
  });

  return overrideSmartText;
};

export const smartTextValueSelector = (state, placeholder) => {
  const smartTextEntities = smartTextSelector(state);
  const placeholderEntity = smartTextEntities[placeholder];

  if (!placeholderEntity) return null;

  return placeholderEntity.value;
};

export const isFetchingTeamSmartText = state => {
  return state.entities.smartText.isFetchingTeamSmartText;
};

export const isFetchingUserSmartText = state => {
  return state.entities.smartText.isFetchingUserSmartText;
};

export const isFetchingSmartText = state => {
  return isFetchingTeamSmartText(state) || isFetchingUserSmartText(state);
};

export const userTeamSmartTextSearchSelector = state => {
  const smartTextEntities = state.entities.smartText.user;
  const smartText = [];
  Object.keys(smartTextEntities).forEach(text => {
    smartText.push(smartTextEntities[text]);
  });
  return smartText;
};

export const designSmartFieldOwnerSelector = state =>
  state.entities.smartAssets.design?.userId;

export const isCurrentDesignSmartFieldOwner = state => {
  if (isEmpty(designSmartTextSelector(state))) return null;

  return designSmartFieldOwnerSelector(state) === state.currentUser.id;
};

export const smartQrCodesSelector = state => {
  const allSmartText = smartTextSelector(state);
  const qrCodes = {};

  Object.keys(allSmartText).forEach(key => {
    if (allSmartText[key].type === "qrcode") {
      qrCodes[key] = allSmartText[key];
    }
  });

  return qrCodes;
};

export const teamSmartQrCodesSelector = state => {
  const teamSmartText = state.entities.smartText.team;
  const qrCodes = {};

  Object.keys(teamSmartText).forEach(key => {
    if (teamSmartText[key].type === "qrcode") {
      qrCodes[key] = teamSmartText[key];
    }
  });

  return qrCodes;
};

export const userTeamSmartQrCodesSelector = state => {
  const userSmartText = state.entities.smartText.user;
  const qrCodes = {};

  Object.keys(userSmartText).forEach(key => {
    if (userSmartText[key].type === "qrcode") {
      qrCodes[key] = userSmartText[key];
    }
  });

  return qrCodes;
};

export const smartTextOnlySelector = state => {
  const allSmartText = smartTextSelector(state);
  const textOnly = {};

  Object.keys(allSmartText).forEach(key => {
    if (allSmartText[key].type !== "qrcode") {
      textOnly[key] = allSmartText[key];
    }
  });

  return textOnly;
};
